/* /arena-assistant — the browser half of the Assistant landing page.
 * Download buttons ([data-dl]): signed out → sign-in, then back here (kraken_return_to); signed in → the
 * installer, plus a logAssistantDownload ping (with the user's ID token when the lazy SDK has one).
 * The sign-in state is the site's isSignedIn flag; for signed-in visitors the SDK loads on idle to
 * confirm it (and re-locks the buttons if the session is gone). Also: the coaching-mode selector.
 */
import "../lib/site.js";
import "../lib/fb-lazy.js";

(function () {
  "use strict";

  var KD = window.KD;
  var EXE = "/downloads/assistant/KTM-Assistant-Setup-latest.exe";
  var FN = "https://us-central1-krakenthemeta.cloudfunctions.net/logAssistantDownload";
  var SIGNIN = "https://krakenthemeta.com/sign-in";
  var btns = KD.$$("[data-dl]"), note = KD.$("[data-note]"), noteHTML = note ? note.innerHTML : "";
  var user = null;

  function paint(signedIn) {
    btns.forEach(function (b) {
      b.setAttribute("href", signedIn ? EXE : SIGNIN);
      if (signedIn) b.setAttribute("download", ""); else b.removeAttribute("download");
    });
    if (note) note.innerHTML = signedIn ? KD.icon("check") + "<span>Signed in: your download starts right away.</span>" : noteHTML;
    if (note) note.classList.toggle("is-ok", signedIn);
  }
  function remember() { try { localStorage.setItem("kraken_return_to", "/arena-assistant"); } catch (e) { /* ignore */ } }

  // fire-and-forget download ping (attributed when signed in); never blocks the download
  function ping() {
    var send = function (tok) {
      try {
        fetch(FN, { method: "POST", keepalive: true, headers: tok ? { "Content-Type": "application/json", Authorization: "Bearer " + tok } : { "Content-Type": "application/json" }, body: JSON.stringify({ page: "arena-assistant" }) }).catch(function () {});
      } catch (e) { /* ignore */ }
    };
    if (user && user.getIdToken) user.getIdToken().then(send).catch(function () { send(null); });
    else send(null);
  }

  paint(KD.signedIn);
  btns.forEach(function (b) {
    b.addEventListener("click", function () {
      if (b.getAttribute("href") === EXE) { ping(); KD.ga("assistant_download", { signed_in: true, transport_type: "beacon" }); }
      else { remember(); KD.ga("assistant_download_signin", { transport_type: "beacon" }); }
    });
  });
  var signinNote = KD.$("[data-signin-note]");
  if (signinNote) signinNote.addEventListener("click", remember);
  KD.$$("[data-pro]").forEach(function (a) { a.addEventListener("click", function () { KD.ga("assistant_pro_click", { where: a.getAttribute("data-pro"), transport_type: "beacon" }); }); });

  if (KD.signedIn) {
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(function () {
      KD.firebase.load().then(KD.firebase.user).then(function (u) { user = u; if (!u) paint(false); }).catch(function () { /* keep the optimistic state */ });
    });
  }

  // ---------------------------------------------------------------- coaching modes
  var MODES = {
    auto: {
      msg: "<b>Auto Pilot:</b> Bolt the Bloodtithe Harvester, then attack with Swiftspear. That lines up lethal next turn.",
      points: ["Your <b>best play, every turn</b>, nothing to click", "Exact casts, attacks and blocks", "Calls <b>lethal</b> you'd miss", "Perfect when you're learning a deck or the game"]
    },
    coach: {
      msg: "<b>Coach:</b> They've kept two Islands untapped since turn 3. What are they representing, and does your attack play into it?",
      points: ["Every turn: <b>what to think about</b>, not the answer", "Reads what your <b>opponent is setting up</b>", "What to aim for based on <b>your deck's game plan</b>", "Still warns you before a game-losing mistake"]
    },
    demand: {
      msg: "<b>You:</b> “What's my play?” The coach reads your real hand and board, and only answers when asked.",
      points: ["<b>Silent until you ask</b>", "“What's my play?” whenever you're stuck", "Ask anything, even paste a screenshot", "A second opinion, on your terms"]
    }
  };
  var ORDER = ["auto", "coach", "demand"];
  var msgEl = KD.$("[data-coach-msg]"), ptsEl = KD.$("[data-coach-points]"), body = KD.$("[data-coach]"), tabs = KD.$$(".acoach__tab");
  var cur = 0, touched = false, timer = 0, swap = 0;
  function show(key) {
    var m = MODES[key];
    if (!m || !msgEl) return;
    cur = ORDER.indexOf(key);
    tabs.forEach(function (t) { var on = t.getAttribute("data-mode") === key; t.classList.toggle("is-on", on); t.setAttribute("aria-selected", String(on)); });
    body.classList.add("is-swapping");
    clearTimeout(swap);
    swap = setTimeout(function () {
      msgEl.innerHTML = m.msg;
      ptsEl.innerHTML = m.points.map(function (p) { return "<li>" + KD.icon("check") + "<span>" + p + "</span></li>"; }).join("");
      body.classList.remove("is-swapping");
    }, KD.reduce ? 0 : 220);
  }
  tabs.forEach(function (t) {
    t.addEventListener("click", function () { touched = true; clearInterval(timer); show(t.getAttribute("data-mode")); KD.ga("assistant_mode", { mode: t.getAttribute("data-mode") }); });
  });
  // rotate gently while the section is on screen and nobody has picked a mode
  if (msgEl && !KD.reduce && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        clearInterval(timer);
        if (e.isIntersecting && !touched) timer = setInterval(function () { if (!touched) show(ORDER[(cur + 1) % ORDER.length]); }, 6000);
      });
    }, { threshold: 0.4 }).observe(body);
  }
})();
